import React from 'react';
import styled from 'styled-components';

import { Typography as T } from 'common/typography';
import { Legends } from 'modules/insights-v2/components/charts/types';

const LegendSeries = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const LegendSquare = styled.div<{ color: string }>`
  background-color: ${({ color }) => color};
  border-radius: 4px;
  height: 12px;
  width: 12px;
`;

const LegendText = styled.div`
  align-items: center;
  display: flex;
  gap: 2px;
`;

const LegendWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

export const AnalyticsChartLegendSeries = ({ legends }: { legends: Legends }) => {
  return (
    <T.Body3>
      <LegendWrapper>
        {Object.entries(legends).map(([key, value]) => (
          <LegendSeries key={key}>
            <LegendSquare color={value.color} />
            <LegendText>
              <T.Body3>{value.value}</T.Body3>
            </LegendText>
          </LegendSeries>
        ))}
      </LegendWrapper>
    </T.Body3>
  );
};
